import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Text from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import { injectProps } from 'helpers/utils'
import { TIRE_SIZE_STATIC_LABEL } from '../constants'

const BOTSearchResult = ({
  placeholders: {
    leftContent = [],
    rightContent = []
  } = {},
  isAllCompatible,
  totalNumRecs,
  resultsLabel,
  compatibilityLabel,
  isRecommendedResultsVisible,
  hasFilters,
  gBBDetails,
  staticLabel,
  isBySizePage
}) =>
  <Fragment>
    <HeadBlock hideContent={ !totalNumRecs && hasFilters }>
      <HeadlineText
        data-at-search-all-results-headline
        headline
        headline_narrow
        inline
        noMargin
        as={ totalNumRecs && isRecommendedResultsVisible ? 'h2' : 'h1' } >
        {isBySizePage ? `${TIRE_SIZE_STATIC_LABEL} ` : `${staticLabel} ` }
        <SearchTitle headline inline>
          {isBySizePage ? `${resultsLabel} TIRES` : resultsLabel }
        </SearchTitle>
      </HeadlineText>
      {
        !!totalNumRecs && !!isAllCompatible &&
        <Compatibility>
          <Check data-at-compatibility-icon asset="check-circle" margin="0 10px 0 0" />
          <CompatibilityText data-at-compatibility-text>These items fit { compatibilityLabel }</CompatibilityText>
        </Compatibility>
      }
    </HeadBlock>
    <Table hideContent={ !totalNumRecs && hasFilters }>
      { injectProps(leftContent, { totalNumRecs }) }
      { injectProps(rightContent, { gBBDetails }) }
    </Table>
  </Fragment>

BOTSearchResult.propTypes = {
  compatibilityLabel: PropTypes.string,
  gBBDetails: PropTypes.shape(),
  hasFilters: PropTypes.bool,
  isAllCompatible: PropTypes.bool,
  isBySizePage: PropTypes.bool,
  isRecommendedResultsVisible: PropTypes.bool,
  placeholders: PropTypes.shape(),
  resultsLabel: PropTypes.string,
  staticLabel: PropTypes.string,
  totalNumRecs: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default BOTSearchResult

const HeadBlock = styled.div`
  ${Mixin.responsive('margin-bottom', '30px', '20px')}
  ${Mixin.clearFix()}
  ${Media.mobile`
    padding: 0 16px;
  `}
  ${props => props.hideContent && css`
    display: none;
  `}
`

const HeadlineText = styled(Text)`
  max-width: 580px;
  word-wrap: break-word;
  ${Media.mobile`
    display: block;
    font-size: 20px;
  `}
`

const SearchTitle = styled(Text)`
  text-transform: none;
  transform: none;
  vertical-align: baseline;
  ${Media.mobile`
    font-size: 20px;
  `}
`

const Compatibility = styled.div`
  position: relative;
  display: inline-block;
  padding: 13px 0 0;
  line-height: 22px;
  color: ${Theme.colors.green};
  vertical-align: top;
  ${Mixin.font.GothamBold(16, 600)}
  ${Media.desktop`
    float: right;
  `}
  ${Media.mobile`
    margin-bottom: 0;
    padding: 13px 0 0 24px;
  `}
`

const Check = styled(Icon)`
  ${Media.mobile`
    position: absolute;
    top: 18px;
    left: 0;
    max-width: 16px;
  `}
`

const CompatibilityText = styled.span`
  ${Mixin.font.GothamBold(16, 600)}
`

const Table = styled.div`
  display: table;
  width: 100%;
  ${Media.mobile`
    padding: 0 16px;
  `}
  ${props => props.hideContent && css`
    display: none;
  `}

  @media (max-width: 340px) {
    padding: 0;
  }
`

